const initialState = {
  dashboard: {
    graph: {
      x: 0
    }
  }
};

export default initialState;
